query materialsForContentCreator($input: MaterialsForContentCreatorInput!) {
  materialsForContentCreator(input: $input) {
    id
    type
    purpose
    mode
    campaignId
    landingpageId
    files {
      file {
        id
        url
        type
        cdnUrl(named: true)
      }
      previewFile {
        id
        url
        cdnUrl
      }
    }
  }
}
